import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import EfisModalParteServicoEncerramento from "../../../../components/UI/EfisModal/EfisModalParteServicoEncerramento";

const useEncerrarParteServicoOs = ({ formik }) => {
  const [showEncerraConfirm, setshowEncerraConfirm] = useState({
    title: null,
    body: null,
    show: false,
  });

  const [Codigo, setCodigo] = useState("")

  const {
    request: requestEncerra,
    data: dataEncerra,
    errors: errorsEncerra,
    isLoading: isLoadingEncerra,
  } = useApiClient();

  const { setErrors } = formik;

  useEffect(() => {
    if (!dataEncerra && !errorsEncerra) return;

    if (dataEncerra) {
      toast.success("Parte de Serviço encerrada com sucesso.");
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }

    if (errorsEncerra) {
      setErrors((curr) => ({ ...curr, ...errorsEncerra }));
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    setshowEncerraConfirm({ show: false });
  }, [setshowEncerraConfirm, dataEncerra, errorsEncerra, setErrors]);

  const excluirDocumentoPs = useCallback(
    (sqParteServico, texto) => {
      requestEncerra(apiRoutes.fiscalizacao.parteservico.encerrarParteServico, { 
        sqParteServico,
        textoJustificativa: texto, 
    });
    },
    [requestEncerra],
  );

  const { request: requestVerificaPs, data: dataVerificaPs } = useApiClient();

  useEffect(() => {
    if (dataVerificaPs) {
      const mensagem = dataVerificaPs.result;
      if (mensagem === "" || mensagem == null) {
        setshowEncerraConfirm({
          title: "Justificativa para encerramento",
          body: `Encerrar PS Nº ${Codigo}`,
          show: true,
          codigo: Codigo,
          situacao: "N",
          justificar: true,
        });
      } else {
        setshowEncerraConfirm({
          title: "Atenção!",
          body: `${mensagem}`,
          show: true,
          justificar: false,
        });
      }
    }
  }, [dataVerificaPs, setshowEncerraConfirm, Codigo]);

  const verificaPs = useCallback(
    (codigo) => {
      setCodigo(codigo);
      requestVerificaPs(
        apiRoutes.fiscalizacao.parteservico.verificaParteServico,
        { sqParteServico: codigo },
      );
    },
    [requestVerificaPs],
  );

  const encerrarPsModal = (
    <>
      <FormAlert formik={formik} data={dataEncerra} errors={errorsEncerra} isLoading={isLoadingEncerra} dismissible />
      <EfisModalParteServicoEncerramento
        show={showEncerraConfirm.show}
        title={showEncerraConfirm.title}
        loadingConfirmationAction={isLoadingEncerra}
        codigo={showEncerraConfirm.codigo}
        situacao={showEncerraConfirm.situacao}
        justificar={showEncerraConfirm.justificar}
        closeHandler={() => setshowEncerraConfirm({ show: false })}
        confirmationHandler={(codigo, texto) => {
          excluirDocumentoPs(codigo, texto);
        }}
        body={showEncerraConfirm.body}
      />
    </>
  );

  return {
    encerrarPsModal,
    setshowEncerraConfirm,
    verificaPs,
  };
};

export default useEncerrarParteServicoOs;
